// extracted by mini-css-extract-plugin
export const root = "carousel-module--root--19-Bg";
export const text = "carousel-module--text--3MIIA";
export const caption = "carousel-module--caption--2iPMt";